type MetaConfig = {
  name: string;
  content: string;
};

export const getWebtrendsParameters = (
  modelNValue: string | undefined,
  modelSValue: string | undefined
): MetaConfig[] => {
  const params: MetaConfig[] = [];

  if (modelNValue) {
    params.push({
      name: 'WT.cg_n',
      content: modelNValue,
    });
  }

  if (modelSValue) {
    params.push({
      name: 'WT.cg_s',
      content: modelSValue,
    });
  }

  return params;
};
